// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38oZG","largestCol":"styles_largestCol__2lhgo","smallestCol":"styles_smallestCol__3hKUX"};